import { Box, Button, Divider, Drawer, Stack, Typography } from "@mui/material";
import { globalTheme } from "../../../styles";
import { WarningIcon } from "../../Icon";
import { IMoveShipmentsButton } from "../../../interfaces/IMoveShipmentsButton";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { UnShippedIcon } from "../../Icon/UnShippedIcon";
import { useState } from "react";

interface ConfirmationDialogProps {
  open?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  orderID?: string;
  shipmentID?: string;
  itemTrackingID?: any;
  customerName?: string;
  onSelectedStatus?: (status: string) => void;
}

export const moveShipmentItems: IMoveShipmentsButton[] = [
  {
    label: "SHIPPED",
    value: "Shipped",
    variant: "outlined",
    size: "small",
    onClick: () => {},
    disable: false,
    color: "primary",
    startIcon: <LocalShippingIcon sx={{ fill: globalTheme.blue }} />,
    iconOpacity: 1,
  },
  {
    label: "UNSHIPPED",
    variant: "outlined",
    value: "Unshipped",
    size: "small",
    onClick: () => {},
    disable: false,
    color: "primary",
    startIcon: <UnShippedIcon />,
    iconOpacity: 1,
  },
  // Will be Used in future
  // {
  //   label: "OnHold",
  //   variant: "outlined",
  //   value: "onhold",
  //   size: "small",
  //   onClick: () => {},
  //   disable: false,
  //   color: "warning",
  // },
  // {
  //   label: "Cancelled",
  //   variant: "outlined",
  //   value: "cancelled",
  //   size: "small",
  //   onClick: () => {},
  //   disable: false,
  //   color: "error",
  // },
];

const ShipmentsDeleteItems = [
  { label: "Order ID:", value: (props: ConfirmationDialogProps) => props.orderID },
  { label: "Customer Name:", value: (props: ConfirmationDialogProps) => props.customerName },
  { label: "Shipment ID:", value: (props: ConfirmationDialogProps) => props.shipmentID },
  { label: "ItemTracking ID:", value: (props: ConfirmationDialogProps) => props.itemTrackingID },
];

export const ShipmentsDeleteConfirmationDrawer = ({
  open,
  onClose,
  onConfirm,
  orderID,
  shipmentID,
  customerName,
  itemTrackingID,
  onSelectedStatus,
}: ConfirmationDialogProps) => {
  const [isMoveShipmentsStatusSelected, setIsMoveShipmentsStatusSelected] = useState(false);
  const [moveShipmentsSelectedStatusButton, setsMoveShipmentsSelectedStatusButton] = useState<string>("");
  const [actionUpdateRequest, setActionUpdateRequest] = useState({ requestAvailable: false, request: [] });

  // const { successfullUpdatedAction } = useUpdateAction({
  //   updateActionRequest: actionUpdateRequest.request,
  //   enabled: actionUpdateRequest.requestAvailable,
  // });

  const handleMoveShipmentsStatusClick = (onClick: () => void, label: string, value: string) => {
    onClick();

    if (moveShipmentsSelectedStatusButton === value) {
      setIsMoveShipmentsStatusSelected(false);
      setsMoveShipmentsSelectedStatusButton("");
      onSelectedStatus("");
    } else {
      setIsMoveShipmentsStatusSelected(true);
      setsMoveShipmentsSelectedStatusButton(value);
      onSelectedStatus(value);
    }
  };
  //contains the selected value
  // console.log("moved status", moveShipmentsSelectedStatusButton);

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 650, padding: "24px", height: "100%" }} display="flex" flexDirection="column" height="100%">
        <Box padding={1} overflow="auto">
          <Box display="flex" alignItems="center" marginTop={2} marginLeft={3} gap={2}>
            <WarningIcon />
            <Typography variant="h6">Change the order shipment status to?</Typography>
          </Box>
          <Divider sx={{ marginTop: 2 }} orientation="horizontal" variant="middle" flexItem />
          <Stack direction="row" justifyContent="space-between" sx={{ p: 1, marginTop: 2 }}>
            {moveShipmentItems.map((button, index) => (
              <Button
                size={button.size}
                variant={button.variant}
                key={index}
                onClick={() => handleMoveShipmentsStatusClick(button.onClick, button.label, button.value)}
                sx={button.variant === "outlined" ? { borderColor: button.borderColor, color: button.color } : {}}
                startIcon={
                  button.startIcon && (
                    <Box
                      component="span"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        opacity:
                          button.disable ||
                          (moveShipmentsSelectedStatusButton !== "" && moveShipmentsSelectedStatusButton !== button.value)
                            ? 0.5
                            : button.iconOpacity,
                      }}
                    >
                      {button.startIcon}
                    </Box>
                  )
                }
                endIcon={button.endIcon}
                color={button.color}
                disabled={moveShipmentsSelectedStatusButton !== "" && moveShipmentsSelectedStatusButton !== button.value}
              >
                {button.label}
              </Button>
            ))}
          </Stack>
        </Box>

        <Divider sx={{ marginTop: 2 }} orientation="horizontal" variant="middle" flexItem />

        {isMoveShipmentsStatusSelected && (
          //conditionalRendering
          <>
            <Box display="flex" alignItems="center" marginTop={2} marginLeft={3} gap={2}>
              <WarningIcon />
              <Typography variant="h6">Confirm Delete</Typography>
            </Box>
            <Divider sx={{ marginTop: 2 }} orientation="horizontal" variant="middle" flexItem />
            <Box flex="1" padding={3} overflow="auto">
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: globalTheme.primaryColor }}>
                Are you sure you want to delete this shipment?
              </Typography>
              <Box marginTop={1} p={1} border={`1px solid ${globalTheme.border}`}>
                {ShipmentsDeleteItems.map((item, index) => (
                  <Box display="flex" component="span" key={index} sx={{ flexDirection: "row" }}>
                    <Box p={1} sx={{ bgcolor: globalTheme.border }} width="50%" borderRight={`1px solid ${globalTheme.border}`}>
                      <Typography variant="body1">{item.label}</Typography>
                    </Box>
                    <Box p={1}>
                      <Typography variant="body1" fontWeight="bold">
                        {item.value({
                          orderID,
                          shipmentID,
                          customerName,
                          itemTrackingID,
                        })}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box padding={1} borderTop={`1px solid ${globalTheme.border}`}>
              <Stack marginTop={2} direction="row" spacing={2} justifyContent="space-between">
                <Button variant="outlined" color="primary" onClick={onClose}>
                  Cancel
                </Button>
                <Button variant="contained" color="error" onClick={onConfirm}>
                  Confirm
                </Button>
              </Stack>
            </Box>
          </>
        )}
      </Box>
    </Drawer>
  );
};
